var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('client-page', {
    scopedSlots: _vm._u([{
      key: "subHead",
      fn: function fn() {
        return [_c('sub-visual', {
          attrs: {
            "sh": "Product",
            "tabActive": "Comfortable & Cozy Line",
            "bg": "/images/sub/visual/sv-product.jpg"
          }
        })];
      },
      proxy: true
    }])
  }, [_c('sub-section', {
    staticClass: "page-section--first page-section--last"
  }, [_c('sub-product', {
    attrs: {
      "tit": "Comfortable & Cozy Line",
      "file": "comfortable"
    }
  }, [_vm._v(" 싱글니트와 타월 테리, 플리스, 텍스쳐 니트 등. 브러쉬 효과와 더불어 다양한 조직을 구현합니다. 홈웨어와 더불어 다양한 룩을 연출하는 소프트 니트 라인은 소비자에게 편안함과 쾌적함을 선사합니다. ")])], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }